/**
 * 請求成功狀態碼
 */
export const SUCCESS_CODE = 200

/**
 * 請求contentType
 */
export const CONTENT_TYPE: AxiosContentType = 'application/json'

/**
 * 請求超時時間
 */
export const REQUEST_TIMEOUT = 60000

/**
 * 不重定向白名單
 */
export const NO_REDIRECT_WHITE_LIST = ['/login']

/**
 * 不重置路由白名單
 */
export const NO_RESET_WHITE_LIST = ['Redirect', 'RedirectWrap', 'Login', 'NoFind', 'Root']

/**
 * 表格默認過濾列設置字段
 */
export const DEFAULT_FILTER_COLUMN = ['expand', 'selection']

/**
 * 是否根據headers->content-type自動轉換數據格式
 */
export const TRANSFORM_REQUEST_DATA = true

/**
 * 全局圖標前綴
 */
export const ICON_PREFIX = 'vi-'
